import { ReturnableItem } from "@redotech/redo-model/return-flow";
import { createContext, useState } from "react";

const CurrentItemBeingReturnedContext = createContext<{
  currentItemBeingReturned: ReturnableItem | undefined;
  setCurrentItemBeingReturned: (
    currentItemBeingReturned: ReturnableItem,
  ) => void;
}>({
  currentItemBeingReturned: undefined,
  setCurrentItemBeingReturned: (currentItemBeingReturned: ReturnableItem) => {},
});

const CurrentItemBeingReturnedContextProvider = ({ children }) => {
  const [currentItemBeingReturned, setCurrentItemBeingReturned] =
    useState<ReturnableItem>(undefined);

  return (
    <CurrentItemBeingReturnedContext.Provider
      value={{ currentItemBeingReturned, setCurrentItemBeingReturned }}
    >
      {children}
    </CurrentItemBeingReturnedContext.Provider>
  );
};

export {
  CurrentItemBeingReturnedContext,
  CurrentItemBeingReturnedContextProvider,
};
